<template>
  <div>

    <a-card :bordered="false" :title="this.title">
      <div>
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item @click="handleClick" key="OrderFlag">{{$t('message.aegOutboundOrderDetail.title.orderStatus')}}</a-menu-item>
          <a-menu-item @click="handleClick" key="BasicFlag" > {{$t('message.aegOutboundOrderDetail.title.basicInformation')}}  </a-menu-item>
          <a-menu-item @click="handleClick" key="SkuFlag" > {{$t('message.aegOutboundOrderDetail.title.skus')}} </a-menu-item>
          <a-menu-item @click="handleClick" key="Guidelines" >{{$t('message.aegOutboundOrderDetail.title.logisticLogs')}} </a-menu-item>
        </a-menu>
      </div>
    </a-card>
    <br>

    <a-card :bordered="false" id="OrderFlag" :title="$t('message.aegOutboundOrderDetail.title.orderStatus')" >
      <a-steps progress-dot :current="this.currentNode" class="a-step-container">
        <template v-for="node in processNodes">
          <a-step :title="node.bizStatusDesc" :description="node.finishTime"/>
        </template>
      </a-steps>
    </a-card>

    <br>
    <a-card :bordered="false" id="BasicFlag" :title="$t('message.aegOutboundOrderDetail.title.basicInformation')" >
      <a-descriptions>

        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.merchantName')">
          {{this.purchaseOrderDetail.supplierName}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.supplierId')">
          {{this.purchaseOrderDetail.supplierId}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.skuVariety')">
          {{this.purchaseOrderDetail.skuQuantity}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.totalQtyDec')">
          {{this.purchaseOrderDetail.totalQtyDec}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.totalReturnQuantity')">
          {{this.purchaseOrderDetail.totalReturnQuantity}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.inventoryType')">
          {{this.purchaseOrderDetail.attributeHolder.inventoryTypeName}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.logisticOrderCode')">
          {{this.purchaseOrderDetail.outOutboundNo}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.creator')">
          {{this.purchaseOrderDetail.creator}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.createTime')">
          {{this.purchaseOrderDetail.attributeHolder.gmtCreateStr}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.outboundTime')">
          {{this.purchaseOrderDetail.attributeHolder.getGmtOutboundStr}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.remark')">
          {{this.purchaseOrderDetail.remark}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.storeName')">
          {{this.purchaseOrderDetail.storeCode}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegOutboundOrderDetail.title.storeCode')">
          {{this.purchaseOrderDetail.storeCode}}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>

    <a-card :bordered="false" id="SkuFlag" :title="$t('message.aegOutboundOrderDetail.title.skus')">
      <a-table :columns="columns" :rowKey="rowKey" :dataSource="dataSource"   :pagination="pagination" :loading="loading" @change="getPurchaseItemsData"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
      </a-table>
    </a-card>

    <a-card :bordered="false" id="Guidelines" :title="$t('message.aegOutboundOrderDetail.title.logisticLogs')">
      <a-table :columns="logisticColumns" :rowKey="rowKey" :dataSource="logisticDataSource">
      </a-table>
    </a-card>

  </div>

</template>

<script>

  import {InboundApi} from '../../js/InboundApi'
  import request from '../../utils/request'
  import {OutboundApi} from '../../js/OnboundApi'

  export default {
  computed: {
    columns () {
      return [
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.scItemId'),
          dataIndex: 'scItemId'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.title'),
          dataIndex: 'title'

        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.barcode'),
          dataIndex: 'barcode'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.brandName'),
          dataIndex: 'brandName'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.quantityDec'),
          dataIndex: 'quantityDec'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.returnQtyDec'),
          dataIndex: 'returnQtyDec'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.remark'),
          dataIndex: 'remark'
        }
      ]
    },
    logisticColumns () {
      return [
        {
          title: this.$t('message.aegOutboundOrderDetail.logisticColumns.operateTime'),
          dataIndex: 'operateTime'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.logisticColumns.operator'),
          dataIndex: 'operator'

        },
        {
          title: this.$t('message.aegOutboundOrderDetail.logisticColumns.bizOrderNo'),
          dataIndex: 'bizOrderNo'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.logisticColumns.fulfillStatus'),
          dataIndex: 'fulfillStatus'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.logisticColumns.fulfillStatusDesc'),
          dataIndex: 'fulfillStatusDesc'
        }
      ]
    },
    goodColumns () {
      return [
        {
          title: this.$t('message.aegInboundDetail.goodsTable.scItemId'),
          dataIndex: 'scItemId'
        },
        {
          title: this.$t('message.aegInboundDetail.goodsTable.title'),
          dataIndex: 'title'

        },
        {
          title: this.$t('message.aegInboundDetail.goodsTable.barcode'),
          dataIndex: 'barcode'
        },
        {
          title: this.$t('message.aegInboundDetail.goodsTable.quantityDec'),
          dataIndex: 'quantityDec'
        },
        {
          title: this.$t('message.aegInboundDetail.goodsTable.normalQtyDec'),
          dataIndex: 'quantityDec'
        },
        {
          title: this.$t('message.aegInboundDetail.goodsTable.normalQtyDec'),
          dataIndex: 'normalQtyDec'
        },
        {
          title: this.$t('message.aegInboundDetail.goodsTable.defectiveQtyDec'),
          dataIndex: 'defectiveQtyDec'
        }
      ]
    },
    consignColumns () {
      return [
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.purchaseOrderNo'),
          dataIndex: 'purchaseOrderNo'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.supplierName'),
          dataIndex: 'supplierName'

        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.inboundNo'),
          dataIndex: 'inboundNo'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.reserveOrderNo'),
          dataIndex: 'reserveOrderNo'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.formatPreArriveTime'),
          dataIndex: 'formatPreArriveTime'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.creator'),
          dataIndex: 'creator'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.gmtCreateStr'),
          dataIndex: 'gmtCreateStr'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.gmtConfirmReceiveStr'),
          dataIndex: 'gmtConfirmReceiveStr'
        }, {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.operate'),
          scopedSlots: {customRender: 'action'}
        }
      ]
    }

  },
  data () {
    return {
      processNodes: [],
      purchaseOrderNo: '',
      title: '',
      currentNode: 0,
      purchaseOrderDetail: null,
      purchaseOrderItems: null,
      pagination: {
        defaultPageSize: 50,
        current: 1,
        pageSize: 50,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.pagination.current = current
          console.log('change current=', this.pagination.current)
          this.getPurchaseItemsData(this.purchaseOrderNo)
        }
      },
      rowKey: 'id',
      loading: true,
      dataSource: this.dataSource,
      selectedRowKeys: [], // Check here to configure the default column,
      consignPagination: {
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.pagination.current = current
          this.queryConsignOrder(this.purchaseOrderNo)
        }
      },
      consignDataSource: this.consignDataSource,
      consignLoading: true,
      newOrderDialog: {
        visible: false,
        confirmLoading: false
      },
      goodDataSource: this.goodDataSource,
      logisticDataSource: this.logisticDataSource
    }
  },
  created () {
    const purchaseLineData = this.$route.query.purchaseLineData
    this.purchaseOrderNo = purchaseLineData.purchaseOrderNo
    this.queryProcessNode(this.purchaseOrderNo)
    this.queryAegPurchaseDetail(this.purchaseOrderNo)
  },
  mounted () {
  },
  methods: {
    onChange (date, dateString) {
    },
    queryProcessNode (purchaseOrderNo) {
      request({
        url: OutboundApi.OutboundFromUrl.queryProcessNodes,
        method: 'get',
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        params: {
          returnOrderNo: purchaseOrderNo
        }
      }).then(response => {
        console.log(response.data.model)
        this.processNodes = response.data.model
        var nodeNum = 0
        this.processNodes.some(function (node) {
          if (node.currentStatus == false) {
            nodeNum = nodeNum + 1
          } else {
            return true
          }
        })
        this.currentNode = nodeNum
        console.log(this.currentNode)
      })
    },
    queryAegPurchaseDetail (purchaseOrderNo) {
      request({
        url: OutboundApi.OutboundFromUrl.queryAegPurchaseOrderDetail,
        method: 'get',
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        params: {
          returnOrderNo: purchaseOrderNo
        }
      }).then(response => {
        this.purchaseOrderDetail = JSON.parse(response.data.model)
        this.getPurchaseItemsData(this.purchaseOrderDetail)
      })
    },
    getPurchaseItemsData (purchaseOrderDetail) {
      const itemDTOList = purchaseOrderDetail.items
      // 遍历item集合
      var arrayIndex = 0
      itemDTOList.some(function (node) {
        arrayIndex++
      })
      this.loading = true
      this.dataSource = itemDTOList
      const pagination = { ...this.pagination }
      // 获取数组大小
      pagination.total = arrayIndex + 1
      this.pagination = pagination
      this.loading = false
    },
    queryConsignOrder (purchaseOrderNo) {
      this.consignLoading = true
      request({
        url: InboundApi.InboundFromUrl.queryConsignOrderUrl,
        method: 'get',
        params: {
          purchaseOrderNo: purchaseOrderNo
        }

      }).then(response => {
        this.consignDataSource = response.data.model
        const pagination = { ...this.pagination }
        // 获取数组大小
        pagination.total = response.data.totalCount
        this.consignPagination = pagination
        this.consignLoading = false
        if (this.consignDataSource != null) {
          this.queryLogisticOrder(this.consignDataSource[0].appointOrderCode, this.consignDataSource[0].consignOrderNo)
        }
      })
    },
    queryLogisticOrder (appointOrderCode, bizOrderNo) {
      request({
        url: InboundApi.InboundFromUrl.queryLogisticOrderUrl,
        method: 'get',
        params: {
          appointOrderCode: appointOrderCode,
          orderCode: bizOrderNo
        }

      }).then(response => {
        this.logisticDataSource = response.data.model
      })
    },
    // 表格选择事件
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    onConsignSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    addNewOrderHandleCancel () {
      this.newOrderDialog.visible = false
    },
    showOrderDetail (record) {
      this.newOrderDialog.visible = true
      this.goodDataSource = record.items
    },
    handleClick (e) {
      console.log(e.key)
      var selector = '#' + e.key
      document.querySelector(selector).scrollIntoView(true, {behavior: 'instant', block: 'start'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/icp/AegOutboundDetail.vue